export const DB_CONFIG ={
    apiKey: "AIzaSyAGPkEu6Ucv3-MsPa_3CpFWBxl4uQ_CJx4",
    authDomain: "klokisoftweb.firebaseapp.com",
    databaseURL: "https://klokisoftweb.firebaseio.com",
    projectId: "klokisoftweb",
    storageBucket: "klokisoftweb.appspot.com",
    messagingSenderId: "273567718363"
}